import { Component, EventEmitter, Input, Output } from '@angular/core';

import { UserInfoSettings } from 'app/shared/models/user-info-settings.model';

@Component({
  selector: 'kh-roles-switcher',
  templateUrl: './roles-switcher.component.html',
  standalone: false
})
export class RolesSwitcherComponent {
  @Input() public usersInfo!: UserInfoSettings;
  public isToggleEnabled = false;
  @Output() public roleSelected = new EventEmitter<string>();
  public onToggle(event: Event): void {
    event.stopPropagation();
    this.isToggleEnabled = !this.isToggleEnabled;
  }

  public onRoleSelect(role: string) {
    this.roleSelected.emit(role);
  }

  public dissableToggle = (): void => {
    this.isToggleEnabled = false;
  };
}
